import ApiButton from 'web-library/stories/atom/Button/ApiButton';
import ErrorInfo from 'web-library/stories/molecule/ErrorInfo/ErrorInfo';
import Box from 'web-library/stories/atom/Box/Box';
import Divider from 'web-library/stories/atom/Divider/Divider';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { MutationStatus } from 'react-query';

interface ProfileDetailsProps {
  verifyCandidateSubmitError?: string;
  invalidPrStatus?: string;
  verifyButtonStatus: MutationStatus;
  classes: Record<string,string>;
  errorTime: number;
}

const ProfileDetailsComponents = ({
  verifyCandidateSubmitError,
  invalidPrStatus,
  verifyButtonStatus,
  classes,
  errorTime,
}: ProfileDetailsProps) => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorInfo label={verifyCandidateSubmitError || invalidPrStatus || ''} />
      <ApiButton
        status={verifyButtonStatus}
        successLabel="Eligible"
        errorLabel="Not Eligible"
        type="submit"
        className={classes.verifyButton}
        successTimeout={1000000}
        errorTimeout={errorTime}
        id="button-verify-candidate"
        disabled={!!invalidPrStatus || verifyButtonStatus === 'success'}
      >
        {t('profile->>CreateCandidateForm.VerifyCandidate')}
      </ApiButton>
      <Divider />
      <Box className={classes.statement}>
        {t('profile->>CreateCandidateForm.PleaseFillUpCompleteAccountCreation')}
      </Box>
    </>
  );
};

export default ProfileDetailsComponents;
